import { Box } from "@mui/material";
import styled from "styled-components";


export const LoaderContainer = styled(Box)`
    height: 12rem;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const SourceDestinationContainer = styled(Box)`
    display: flex;
    gap: .5rem;
    align-items: center;
    > img {
        width: 1.8rem;
    }
`

export default { LoaderContainer, SourceDestinationContainer };